import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Promotion, PromotionView, SweepstakesEntry, SweepstakesParticipationStatus } from '../models';
import { SessionStore } from '../stores';

@Injectable({
  providedIn: 'root'
})
export class PromotionService {
  private http = inject(HttpClient);
  private sessionStore = inject(SessionStore);
  private apiUrl = `${environment.apiUrl}/promotions`;

  /**
   * Obtener promoción pública (sin requerir autenticación)
   * Usado en el landing page desde QR
   */
  getPublicPromotion(id: number): Observable<Promotion> {
    return this.http.get<Promotion>(`${this.apiUrl}/public/${id}`);
  }

  /**
   * Obtener promoción (requiere autenticación)
   */
  getPromotion(id: number): Observable<Promotion> {
    return this.http.get<Promotion>(`${this.apiUrl}/${id}`);
  }

  /**
   * Obtener promociones activas de una empresa
   */
  getActivePromotions(companyId: number): Observable<Promotion[]> {
    return this.http.get<Promotion[]>(`${this.apiUrl}/public/company/${companyId}`);
  }

  /**
   * Tracking de vista de promoción (no requiere auth)
   */
  trackView(promotionId: number, deviceId?: number): Observable<void> {
    const sessionId = this.sessionStore.getOrCreateSessionId();
    const viewData: PromotionView = {
      promotionId,
      deviceId,
      sessionId,
      timestamp: new Date()
    };
    return this.http.post<void>(`${this.apiUrl}/public/${promotionId}/track-view`, viewData);
  }

  getSweepstakesParticipationStatus(promotionId: number): Observable<SweepstakesParticipationStatus> {
    return this.http.get<SweepstakesParticipationStatus>(`${this.apiUrl}/public/${promotionId}/sweepstakes/status`);
  }

  enterSweepstakes(promotionId: number): Observable<SweepstakesEntry> {
    return this.http.post<SweepstakesEntry>(`${this.apiUrl}/public/${promotionId}/sweepstakes/enter`, {});
  }
}
